import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f715b90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-eer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 9,
  class: "eer-footer"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_SwipeStepper = _resolveComponent("SwipeStepper")
  const _component_FormHeader = _resolveComponent("FormHeader")
  const _component_FormEerOverview = _resolveComponent("FormEerOverview")
  const _component_FormEerGeneralTrustMoney = _resolveComponent("FormEerGeneralTrustMoney")
  const _component_FormEerControlledMoney = _resolveComponent("FormEerControlledMoney")
  const _component_FormEerSpecificPowerMoney = _resolveComponent("FormEerSpecificPowerMoney")
  const _component_FormEerInvestmentMoney = _resolveComponent("FormEerInvestmentMoney")
  const _component_FormEerOtherInformation = _resolveComponent("FormEerOtherInformation")
  const _component_FormEerBreaches = _resolveComponent("FormEerBreaches")
  const _component_FormEerDeclaration = _resolveComponent("FormEerDeclaration")
  const _component_FormEerConfirmation = _resolveComponent("FormEerConfirmation")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")
  const _component_SessionExpired = _resolveComponent("SessionExpired")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isSectionLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_SwipeStepper, {
      navSteps: _ctx.navSteps,
      showHelpBtn: true,
      showFaqBtn: true
    }, null, 8, ["navSteps"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormHeader, {
        formName: _ctx.formName,
        formDesc: _ctx.formDesc
      }, null, 8, ["formName", "formDesc"]),
      (_ctx.currentSection === _ctx.$Section.overview)
        ? (_openBlock(), _createBlock(_component_FormEerOverview, {
            key: 0,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[0] || (_cache[0] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[1] || (_cache[1] = $event => ((_ctx.formEERData) = $event)),
            onSetFormDesc: _cache[2] || (_cache[2] = $event => (_ctx.setFormDescription($event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.generalTrustMoney)
        ? (_openBlock(), _createBlock(_component_FormEerGeneralTrustMoney, {
            key: 1,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[3] || (_cache[3] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[4] || (_cache[4] = $event => ((_ctx.formEERData) = $event)),
            onValidForm: _cache[5] || (_cache[5] = $event => (_ctx.validationForm( 1, $event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.controlledMoney)
        ? (_openBlock(), _createBlock(_component_FormEerControlledMoney, {
            key: 2,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[6] || (_cache[6] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[7] || (_cache[7] = $event => ((_ctx.formEERData) = $event)),
            onValidForm: _cache[8] || (_cache[8] = $event => (_ctx.validationForm( 2, $event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.specificPowerMoney)
        ? (_openBlock(), _createBlock(_component_FormEerSpecificPowerMoney, {
            key: 3,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[9] || (_cache[9] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[10] || (_cache[10] = $event => ((_ctx.formEERData) = $event)),
            onValidForm: _cache[11] || (_cache[11] = $event => (_ctx.validationForm( 3, $event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.investmentMoney)
        ? (_openBlock(), _createBlock(_component_FormEerInvestmentMoney, {
            key: 4,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[12] || (_cache[12] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[13] || (_cache[13] = $event => ((_ctx.formEERData) = $event)),
            onValidForm: _cache[14] || (_cache[14] = $event => (_ctx.validationForm( 4, $event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.otherInformation)
        ? (_openBlock(), _createBlock(_component_FormEerOtherInformation, {
            key: 5,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[15] || (_cache[15] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[16] || (_cache[16] = $event => ((_ctx.formEERData) = $event)),
            onValidForm: _cache[17] || (_cache[17] = $event => (_ctx.validationForm( 5, $event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.breaches)
        ? (_openBlock(), _createBlock(_component_FormEerBreaches, {
            key: 6,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[18] || (_cache[18] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[19] || (_cache[19] = $event => ((_ctx.formEERData) = $event)),
            onValidForm: _cache[20] || (_cache[20] = $event => (_ctx.validationForm( 6, $event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.declaration)
        ? (_openBlock(), _createBlock(_component_FormEerDeclaration, {
            key: 7,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[21] || (_cache[21] = $event => ((_ctx.isSectionLoading) = $event)),
            formEERData: _ctx.formEERData,
            "onUpdate:formEERData": _cache[22] || (_cache[22] = $event => ((_ctx.formEERData) = $event)),
            onValidForm: _cache[23] || (_cache[23] = $event => (_ctx.validationForm( 7, $event)))
          }, null, 8, ["isSectionLoading", "formEERData"]))
        : _createCommentVNode("", true),
      (_ctx.currentSection === _ctx.$Section.confirmation)
        ? (_openBlock(), _createBlock(_component_FormEerConfirmation, {
            key: 8,
            isSectionLoading: _ctx.isSectionLoading,
            "onUpdate:isSectionLoading": _cache[24] || (_cache[24] = $event => ((_ctx.isSectionLoading) = $event))
          }, null, 8, ["isSectionLoading"]))
        : _createCommentVNode("", true),
      (!_ctx.isSectionLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.isSaving)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                  key: 0,
                  loadingText: _ctx.savingText,
                  class: "mr-4"
                }, null, 8, ["loadingText"]))
              : _createCommentVNode("", true),
            (_ctx.backButtonVisible)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-outline mr-2",
                  onClick: _cache[25] || (_cache[25] = $event => (_ctx.goBack())),
                  disabled: _ctx.isSaving || _ctx.isSectionLoading
                }, _toDisplayString(_ctx.backButtonText), 9, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.currentSection !== _ctx.$Section.overview && _ctx.currentSection !== _ctx.$Section.confirmation)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-secondary mr-2",
                  disabled: _ctx.isSaving || _ctx.isSectionLoading,
                  onClick: _cache[26] || (_cache[26] = $event => (_ctx.saveSection(false, true)))
                }, "Save", 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.canGoNext() || _ctx.isSaving || _ctx.isSectionLoading,
              onClick: _cache[27] || (_cache[27] = $event => (_ctx.goNext()))
            }, [
              _createTextVNode(_toDisplayString(_ctx.nextButtonText), 1),
              _hoisted_7
            ], 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmSaveClose",
      modalOpened: true
    }, null, 512),
    (_ctx.showSessionExpiredModal)
      ? (_openBlock(), _createBlock(_component_SessionExpired, {
          key: 1,
          modalOpened: _ctx.showSessionExpiredModal,
          onClose: _cache[28] || (_cache[28] = $event => (_ctx.exitForm()))
        }, null, 8, ["modalOpened"]))
      : _createCommentVNode("", true)
  ]))
}